import type { ComponentSchema } from "../../../../../schema-types"
import { primaryButtonFields, outlineButtonFields } from "../shared/button-schema-fields"

export const schema: ComponentSchema = {
  type: 'shop-grid',
  label: 'Shop Grid',
  description: 'The main product list with sidebar filters.',
  supportedPages: ['shop', 'category', 'cart', 'checkout', 'categories'],
  variants: [{ id: 'v1', label: 'V1 (Classic Sticky Sidebar)' }],
  commonFields: [
    { key: 'title', label: 'Section Title', type: 'string' },
    { key: 'description', label: 'Description', type: 'text' },
    {
      key: 'sidebarVariant',
      label: 'Sidebar Style',
      type: 'select',
      options: [{ label: 'Standard (V1)', value: 'v1' }],
      default: 'v1',
    },
    {
      key: 'productCardVariant',
      label: 'Product Card Style',
      type: 'select',
      options: [
        { label: 'Standard (V1)', value: 'v1' },
        { label: 'Clean (V2)', value: 'v2' },
      ],
      default: 'v1',
    },
    {
      key: 'paginationVariant',
      label: 'Pagination Style',
      type: 'select',
      options: [{ label: 'Standard (V1)', value: 'v1' }],
      default: 'v1',
    },
    { key: 'initialPriceRange.min', label: 'Initial Price Min', type: 'number', default: 0 },
    { key: 'initialPriceRange.max', label: 'Initial Price Max', type: 'number', default: 50000 },
    { key: 'itemsPerPage', label: 'Items Per Page', type: 'number', default: 12 },
    { key: 'allCategoriesLabel', label: 'All Categories Label', type: 'string', default: 'All' },
    { key: 'filtersButtonLabel', label: 'Filters Button Label', type: 'string', default: 'Filters' },
    { key: 'showingLabel', label: 'Showing Label (prefix)', type: 'string', default: 'Showing' },
    { key: 'productsSuffix', label: 'Products Count Suffix', type: 'string', default: 'Products' },
    { key: 'sortNewestLabel', label: 'Sort: Newest Label', type: 'string', default: 'Sort: Newest' },
    { key: 'sortOldestLabel', label: 'Sort: Oldest Label', type: 'string', default: 'Sort: Oldest' },
    { key: 'sortPriceAscLabel', label: 'Sort: Price Low-High Label', type: 'string', default: 'Price: Low to High' },
    { key: 'sortPriceDescLabel', label: 'Sort: Price High-Low Label', type: 'string', default: 'Price: High to Low' },
    { key: 'sortNameAscLabel', label: 'Sort: Name A-Z Label', type: 'string', default: 'Name: A-Z' },
    { key: 'sortNameDescLabel', label: 'Sort: Name Z-A Label', type: 'string', default: 'Name: Z-A' },
    { key: 'activeFiltersLabel', label: 'Active Filters Label', type: 'string', default: 'Active Filters:' },
    { key: 'clearAllLabel', label: 'Clear All Label', type: 'string', default: 'Clear All' },
    { key: 'noProductsTitle', label: 'No Products Title', type: 'string', default: 'No Products Found' },
    { key: 'noProductsMessage', label: 'No Products Message', type: 'string', default: "We couldn't find any products matching your current filters. Try adjusting them." },
    { key: 'backToAllText', label: 'Back to All Products Text', type: 'string', default: 'Back to All Products' },
    { key: 'filterDrawerTitle', label: 'Filter Drawer Title', type: 'string', default: 'Filter Products' },
    { key: 'currentSearchLabel', label: 'Current Search Label', type: 'string', default: 'Current Search' },
    { key: 'clearSearchLabel', label: 'Clear Search Label', type: 'string', default: 'Clear' },
    { key: 'applyFiltersLabel', label: 'Apply Filters Label', type: 'string', default: 'Apply Filters' },

    // ─── Product Card Buttons ─────────────────────────────────────────
    ...primaryButtonFields('buttons.orderNow', 'Order Now Button'),
    ...outlineButtonFields('buttons.addToCart', 'Add to Cart Button'),
  ],
}
